export default __webpack_public_path__ + "static/media/bottom-img.4903613e.png";